import { User, UserOption } from "./user";

export class ProblemIdentification {
  id?: string;
  area: EntityOption;
  monthYtd: string;
  responsible: User;
  coResponsible: UserOption[];
  problemDescription: string;
  kpi: string;
  frequency: string;
  calculationMethod: string;
  target: number;
  current: number;
  percentage: number;
  nature: string;
  unitOfMeasure: string;
  deadline: string;
}

export class EntityOption {
  id: string;
  name: string;
  description?: string;
}
